"use client";

import React from "react";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
import { Link } from "@/components/common/Link";
import { House as Home, CirclePlay as PlayCircle, Shield, Send, MapPin, User } from 'lucide-react';
function BottomNavContent() {
  const {
    menuItems,
    loading
  } = useMenu();
  const defaultItems = [{
    id: '1',
    label: 'HOME',
    href: '/HomePage',
    icon: Home
  }, {
    id: '2',
    label: 'LIVE',
    href: '/LivePage',
    icon: PlayCircle
  }, {
    id: '3',
    label: 'ZONA PP',
    href: '/PPZonePage',
    icon: Shield
  }, {
    id: '4',
    label: 'KIRIM',
    href: '/SendNewsPage',
    icon: Send
  }, {
    id: '5',
    label: 'POJOK OJOL',
    href: '/RideHailingCornerPage',
    icon: MapPin
  }];
  const itemsToRender = loading || !menuItems?.length ? defaultItems : menuItems.map(item => {
    let Icon = Home;
    const labelLower = item.label.toLowerCase();
    if (labelLower.includes('live')) Icon = PlayCircle;else if (labelLower.includes('zona')) Icon = Shield;else if (labelLower.includes('kirim')) Icon = Send;else if (labelLower.includes('akun')) Icon = User;else if (labelLower.includes('ojol')) Icon = MapPin;
    return {
      ...item,
      icon: Icon
    };
  });
  return <div className="relative flex h-full w-full items-center justify-between px-1">
      {}
      <div className="pointer-events-none absolute inset-x-0 top-0 h-1/2 bg-gradient-to-b from-primary-foreground/40 to-transparent" />

      {itemsToRender.slice(0, 5).map((item, i) => {
      const Icon = item.icon || Home;
      return <div key={item.id} data-index={i} className="contents">
            <Link to={item.href || "#"} className="group relative z-10 flex h-full flex-1 flex-col items-center justify-center gap-0.5">
              <div className="relative flex items-center justify-center transition-transform duration-300 group-hover:-translate-y-1 group-active:scale-95">
                {}
                <div className="absolute inset-0 rounded-lg bg-primary-foreground/20 opacity-0 blur-md transition-opacity group-hover:opacity-100" />
                <Icon className="relative z-10 size-5 text-primary-foreground drop-shadow-md" strokeWidth={2.5} />
              </div>
              <span className="font-default text-[10px] font-bold tracking-wider text-primary-foreground uppercase drop-shadow-md">
                {item.label}
              </span>
            </Link>

            {}
            {i < Math.min(itemsToRender.length, 5) - 1 && <div className="relative z-10 h-8 w-px shrink-0 bg-gradient-to-b from-transparent via-primary-foreground/50 to-transparent" />}
          </div>;
    })}
    </div>;
}
export default function GlossyBottomNavigation() {
  return <section id="glossybottomnavigation" className="fixed right-0 bottom-0 left-0 z-50 h-[56px] w-full border-t border-primary-foreground/20 bg-gradient-to-b from-primary to-primary/90 shadow-2xl">
      <MenuProvider menu_id="1172" className="h-full w-full">
        <BottomNavContent />
      </MenuProvider>
    </section>;
}